import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getParcelStatus } from '../shippingService'

export const useParcelStatus = (trackingNumber: string | undefined, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PARCEL_STATUS, trackingNumber],
    queryFn: () => getParcelStatus(trackingNumber!),
    enabled: enabled && !!trackingNumber,
  })
}
